import { type ComponentPropsWithoutRef, memo } from 'react';

import { ChevronDownIcon } from '@air/design-icons';
import { Button, type ButtonProps } from '@air/primitive-button';
import { cn } from '@air/utils-tailwind';

export type GallerySectionHeaderProps = ComponentPropsWithoutRef<'div'> & {
  collapsed?: boolean;
  onToggleCollapse?: ButtonProps['onClick'];
  /** Identifies which section this is (e.g. "Boards"), so tests can target one directly instead of
   * by position — sections can drop out of the list or reorder as their item counts change. */
  sectionLabel?: string;
};

export const GallerySectionHeader = memo(
  ({ children, className, collapsed, onToggleCollapse, sectionLabel, ...restOfProps }: GallerySectionHeaderProps) => {
    return (
      <div className={cn('group/gallery-section-header', className)} data-collapsed={collapsed} {...restOfProps}>
        <Button
          data-testid="GALLERY_SECTION_HEADER_TOGGLE_BUTTON"
          data-section-label={sectionLabel}
          appearance="ghost"
          color="gray"
          onClick={onToggleCollapse}
          size="small"
          suffix={
            <ChevronDownIcon
              className="transition-transform group-data-[collapsed=true]/gallery-section-header:-rotate-90"
              size="xs"
            />
          }
        >
          <span className="font-bold uppercase tracking-wider">{children}</span>
        </Button>
      </div>
    );
  },
);

GallerySectionHeader.displayName = 'GallerySectionHeader';
